export default __webpack_public_path__ + "static/media/master_data.9eb2eb4e.svg";